// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content-container":"_13AkYW"};